import { ref, push, serverTimestamp, query, orderByChild, equalTo, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import { getAuth } from 'firebase/auth';

const auth = getAuth();

export const recordPurchaseBillings = async (userId, amount, creditsPurchased, paymentMethod) => {
  const billingRef = ref(database, 'Billing/'+ userId);
  try {
    const newPurchase = {
      UserID: userId,  // Changed from userId to UserID
      amount,
      creditsPurchased,
      paymentMethod,
      date: new Date(Date.now()).toLocaleString("en-US", { timeZone: "America/New_York" }) //mm/dd/yyyy hh:mmm:ss t
    };
    const newPurchaseRef = await push(billingRef, newPurchase);
    console.log('Billing record inserted');
    //return newPurchaseRef.key;
  } catch (error) {
    //console.error('Error recording billing record:', error);
    throw error;
  }
};




